var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"menu-list"},_vm._l((_vm.articles),function(article,index){return _c('li',{staticClass:"item menu-item",class:{active: article.active},on:{"click":function($event){_vm.goTo(index)}}},[_vm._v(" "+_vm._s(article.shortText || article.text))])}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-520bd0a6","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExploreMenu.vue
// module id = null
// module chunks = 